export class Helper {

	static getWeekDays() {
		return [
			'Pondělí',
			'Úterý',
			'Středa',
			'Čtvrtek',
			'Pátek',
			'Sobota',
			'Neděle'
		];
	}

	static detectIE() {
		var ua = window.navigator.userAgent;

		var msie = ua.indexOf('MSIE ');
		if(msie > 0) {
			// IE 10 or older => return version number
			return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
		}

		var trident = ua.indexOf('Trident/');
		if(trident > 0) {
			// IE 11 => return version number
			var rv = ua.indexOf('rv:');
			return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
		}

		var edge = ua.indexOf('Edge/');
		if(edge > 0) {
			// Edge (IE 12+) => return version number
			return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
		}

		// other browser
		return false;
	}

	static getHoursString(hours) {
		let s;
		if(hours === 1) {
			s = 'hodinu';
		} else if(2 <= hours && hours <= 4) {
			s = 'hodiny';
		} else if(hours > 4) {
			s = 'hodin';
		}
		return s;
	}

	static encodeQueryData(data) {
		let ret = [];
		for(let d in data) {
			ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
		}
		return ret.join('&');
	}

	static isResponsive() {
		return $(window)
			.width() < 768;
	}

	static isMobile() {
		if($(window)
			.width() < 1030) {
			return true;
		}
		return false;

	}

	/**
	 *
	 * @param price
	 * @returns {string}
	 */
	static formatIntToPrice(price) {
		price = Math.round(Helper.getFloat(price));
		return price.toString()
					.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	}

	/**
	 *
	 * @param price
	 * @returns {string}
	 */
	static formatIntToPriceUp(price) {
		price = Math.ceil(Helper.getFloat(price));
		return price.toString()
					.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	}

	/**
	 *
	 * @param price
	 * @param to
	 * @returns {string}
	 */
	static formatIntToPriceUpTo(price, to = 5000) {

		price = Math.ceil(Helper.getFloat(price));

		let upTo = Math.round(price / to) * to;
		if(upTo < price) {
			upTo = upTo + to;
		}

		return upTo.toString()
				   .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');


	}

	/**
	 *
	 * @param number
	 * @returns {*}
	 */
	static getFloat(number) {
		if(typeof number == 'number') {
			return number;
		}
		try {
			let parsed = parseFloat(number.split(' ')
										  .join(''));
			return parsed ? parsed : 0;
		} catch(e) {
			return 0;
		}

	};

	static getIntFromString(price) {
		if(price) {
			return parseInt(price.toString()
								 .replace(/\D/g, ''));
		}
	};

	static roundThousandsUp(number) {
		return Math.ceil(number / 1000) * 1000;
	};

	static roundTensUp(number) {
		return Math.ceil(number / 10) * 10;
	};

	static bytesToSize(bytes) {
		let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
		if(bytes == 0) {
			return '0 Byte';
		}
		let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
		return Math.round(bytes / Math.pow(1024, i), 2) + '' + sizes[i];
	};

	static isJson(str) {
		try {
			JSON.parse(str);
		} catch(e) {
			return false;
		}
		return true;
	}


}